import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
/**
 * Matches an italic to a *italic* on input.
 */

var starInputRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */

var starPasteRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */

var underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */

var underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */

var Italic = Mark.create({
  name: 'italic',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    var _this = this;

    return [{
      tag: 'em'
    }, {
      tag: 'i',
      getAttrs: function getAttrs(node) {
        return node.style.fontStyle !== 'normal' && null;
      }
    }, {
      style: 'font-style=normal',
      clearMark: function clearMark(mark) {
        return mark.type.name === _this.name;
      }
    }, {
      style: 'font-style=italic'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      setItalic: function setItalic() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this2.name);
        };
      },
      toggleItalic: function toggleItalic() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this2.name);
        };
      },
      unsetItalic: function unsetItalic() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this2.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      'Mod-i': function ModI() {
        return _this3.editor.commands.toggleItalic();
      },
      'Mod-I': function ModI() {
        return _this3.editor.commands.toggleItalic();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: starInputRegex,
      type: this.type
    }), markInputRule({
      find: underscoreInputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: starPasteRegex,
      type: this.type
    }), markPasteRule({
      find: underscorePasteRegex,
      type: this.type
    })];
  }
});
export { Italic, Italic as default, starInputRegex, starPasteRegex, underscoreInputRegex, underscorePasteRegex };